//specific jump to link for CL pages
// ON click check if there are offices, then ports. If none, do nothing
// Old C&L

$(document).ready(function(){
    var $jumpButton = $('#cl-jump-to');
    var $offices = $('#offices');
    var $ports = $('#ports');
   
    if($jumpButton.length){
        $jumpButton.on('click', function(){
            if($offices.length){
                $('html,body').animate({
                    scrollTop: $offices.offset().top
                }, 500);
            } else if($ports.length){
                $('html,body').animate({
                    scrollTop: $ports.offset().top
                }, 500);
            }
        })
    }
});